import React, { useState, useEffect } from 'react';

import { r2_unfilteredList } from '../../Helpers/r2_requests';

import { sumArrayObjects, multiplyArrayObjects } from '../../Helpers/helpers';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';

import GlobalNotes from '../CommonComponents/GlobalNotes';

import {
  Box,
  Button,
  Grid,
  Typography,
  Divider,
  // Checkbox,
  TextField,
  Stack,
  Switch,
} from '@mui/material';

import { ticketTypoTitle, ticketTypoInfo } from '../shared/commonStyle';

const BillingNoteInstall = (props) => {
  const closeModal = props.closeModel;
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  const [forceUpdate, setForceUpdate] = useState(1);

  const ticketData = props.ticketData;
  const relationId = props.relationId;

  const [fullTicketData, setFullTicketData] = useState([]);
  const [newTicketData, set_newTicketData] = useState({});

  const [timeData, setTimeData] = useState({
    nt_minutes: 0,
    ot1_minutes: 0,
    ot2_minutes: 0,
  });

  // console.log(ticketData);
  const ticketID = props.relationId;

  const [billingData, setBillingData] = useState([]);

  const [ir_stamped, set_ir_stamped] = useState('');
  const [dn_stamped, set_dn_stamped] = useState('');
  const [iw_stamped, set_iw_stamped] = useState('');

  const [labour_rate, set_labour_rate] = useState('0');
  const [travel_rates, set_travel_rates] = useState('0');
  const [travel_per_km, set_travel_per_km] = useState('0');

  const [t_labourTimeNT, set_t_labourTimeNT] = useState('0');
  const [t_labourTimeOT1, set_t_labourTimeOT1] = useState('0');
  const [t_labourTimeOT2, set_t_labourTimeOT2] = useState('0');

  const [t_budget_labourTimeNT, set_t_budget_labourTimeNT] = useState('0');
  const [t_budget_labourTimeOT1, set_t_budget_labourTimeOT1] = useState('0');
  const [t_budget_labourTimeOT2, set_t_budget_labourTimeOT2] = useState('0');

  const [t_travelTimeNT, set_t_travelTimeNT] = useState('0');
  const [t_travelTimeOT1, set_t_travelTimeOT1] = useState('0');
  const [t_travelTimeOT2, set_t_travelTimeOT2] = useState('0');

  const [t_budget_travelTimeNT, set_t_budget_travelTimeNT] = useState('0');
  const [t_budget_travelTimeOT1, set_t_budget_travelTimeOT1] = useState('0');
  const [t_budget_travelTimeOT2, set_t_budget_travelTimeOT2] = useState('0');

  const [t_travelKM, set_t_travelKM] = useState('0');
  const [t_budget_travelKM, set_t_budget_travelKM] = useState('0');

  const [t_accAndSnt, set_t_accAndSnt] = useState('0');
  const [t_budget_accAndSnt, set_t_budget_accAndSnt] = useState('0');

  const [t_forkliftCrane, set_t_forkliftCrane] = useState('0');
  const [t_budget_forkliftCrane, set_t_budget_forkliftCrane] = useState('0');

  const [t_toolHire, set_t_toolHire] = useState('0');
  const [t_budget_toolHire, set_t_budget_toolHire] = useState('0');

  const [t_casualHire, set_t_casualHire] = useState('0');
  const [t_budget_casualHire, set_t_budget_casualHire] = useState('0');

  const [t_trailerHire, set_t_trailerHire] = useState('0');
  const [t_budget_trailerHire, set_t_budget_trailerHire] = useState('0');

  const [t_other, set_t_other] = useState('0');
  const [t_budget_other, set_t_budget_other] = useState('0');

  const [t_transport, set_t_transport] = useState('0');
  const [t_budget_transport, set_t_budget_transport] = useState('0');

  const [t_workInstruction, set_t_workInstruction] = useState('');
  const [t_invoiceNumber, set_t_invoiceNumber] = useState('');
  const [t_quoteNumber, set_t_quoteNumber] = useState('');

  useEffect(() => {
    r2_unfilteredList({
      resource: `/api/r2_install_tickets/${relationId}`,
      setDataFunc: setFullTicketData,
      showNotification: enqNotification,
      logout,
      payloadBlob: {},
    });
  }, [enqNotification, logout, relationId]);

  // console.log('FULL', fullTicketData);

  useEffect(() => {
    checkBillingInfo(fullTicketData).then((data) => {
      setBillingData(data);
    });
    checkTicketInfo(fullTicketData).then((data) => {
      set_newTicketData(data);
    });
    checkClock(relationId).then((data) => {
      setTimeData(data.data.value);
    });
  }, [fullTicketData, relationId]);
  // console.log(timeData);

  // console.log('BILLING', newTicketData.dn_number);

  const checkTicketInfo = async (arr) => {
    let data;
    if (arr['install_ticket'] === undefined) {
      data = {
        capex_number: '',
        dn_number: '',
        q_number: '',
      };
    } else {
      data = await arr['install_ticket'];
    }
    return data;
  };

  const checkBillingInfo = async (arr) => {
    let data;
    if (arr['billingnote'][0] === undefined) {
      data = {
        ir_stamped: '',
        dn_stamped: '',
        iw_stamped: '',
        labour_rate: 380.0,
        travel_rates: 380.0,
        travel_per_km: 4.5,
        t_budget_labourTimeNT: '0',
        t_budget_labourTimeOT1: '0',
        t_budget_labourTimeOT2: '0',
        t_travelTimeNT: '0',
        t_travelTimeOT1: '0',
        t_travelTimeOT2: '0',
        t_budget_travelTimeNT: '0',
        t_budget_travelTimeOT1: '0',
        t_budget_travelTimeOT2: '0',
        t_travelKM: '0',
        t_budget_travelKM: '0',
        t_accAndSnt: '0',
        t_budget_accAndSnt: '0',
        t_forkliftCrane: '0',
        t_budget_forkliftCrane: '0',
        t_toolHire: '0',
        t_budget_toolHire: '0',
        t_casualHire: '0',
        t_trailerHire: '0',
        t_budget_trailerHire: '0',
        t_budget_casualHire: '0',
        t_other: '0',
        t_budget_other: '0',
        t_transport: '0',
        t_budget_transport: '0',
        t_workInstruction: '',
        t_invoiceNumber: '',
      };
    } else {
      data = await arr['billingnote'][0];
    }
    // console.log('DATA', data);
    return data;
  };

  useEffect(() => {
    let data = billingData;
    // console.log('DATA: ', data);
    set_ir_stamped(data.ir_stamped);
    set_dn_stamped(data.dn_stamped);
    set_iw_stamped(data.iw_stamped);
    set_labour_rate(data.labour_rate);
    set_travel_rates(data.travel_rates);
    set_travel_per_km(data.travel_per_km);
    // ------------------------ //
    set_t_labourTimeNT(data.t_labourTimeNT);
    set_t_labourTimeOT1(data.t_labourTimeOT1);
    set_t_labourTimeOT2(data.t_labourTimeOT2);
    set_t_budget_labourTimeNT(data.t_budget_labourTimeNT);
    set_t_budget_labourTimeOT1(data.t_budget_labourTimeOT1);
    set_t_budget_labourTimeOT2(data.t_budget_labourTimeOT2);
    // ------------------------ //
    set_t_travelTimeNT(data.t_travelTimeNT);
    set_t_travelTimeOT1(data.t_travelTimeOT1);
    set_t_travelTimeOT2(data.t_travelTimeOT2);
    set_t_budget_travelTimeNT(data.t_budget_travelTimeNT);
    set_t_budget_travelTimeOT1(data.t_budget_travelTimeOT1);
    set_t_budget_travelTimeOT2(data.t_budget_travelTimeOT2);
    // ------------------------ //
    set_t_travelKM(data.t_travelKM);
    set_t_budget_travelKM(data.t_budget_travelKM);
    // ------------------------ //
    set_t_accAndSnt(data.t_accAndSnt);
    set_t_budget_accAndSnt(data.t_budget_accAndSnt);
    set_t_forkliftCrane(data.t_forkliftCrane);
    set_t_budget_forkliftCrane(data.t_budget_forkliftCrane);
    set_t_toolHire(data.t_toolHire);
    set_t_budget_toolHire(data.t_budget_toolHire);
    set_t_casualHire(data.t_casualHire);
    set_t_budget_casualHire(data.t_budget_casualHire);
    set_t_trailerHire(data.t_trailerHire);
    set_t_budget_trailerHire(data.t_budget_trailerHire);
    set_t_other(data.t_other);
    set_t_budget_other(data.t_budget_other);
    set_t_transport(data.t_transport);
    set_t_budget_transport(data.t_budget_transport);
    set_t_workInstruction(data.t_workInstruction);
    set_t_invoiceNumber(data.t_invoiceNumber);
    set_t_quoteNumber(data?.t_quoteNumber ? data?.t_quoteNumber : '');
  }, [billingData]);

  const combineData = () => {
    let ticketBlob = {
      install_ticket: {
        ticket_type: ticketData['install_ticket'].ticket_type,
        status: ticketData['install_ticket'].status,
        customer_id: newTicketData.customer_id,
      },
      billingnote: [
        {
          ir_stamped: ir_stamped,
          dn_stamped: dn_stamped,
          iw_stamped: iw_stamped,
          labour_rate: labour_rate,
          travel_rates: travel_rates,
          travel_per_km: travel_per_km,
          t_budget_labourTimeNT: t_budget_labourTimeNT,
          t_budget_labourTimeOT1: t_budget_labourTimeOT1,
          t_budget_labourTimeOT2: t_budget_labourTimeOT2,
          t_travelTimeNT: t_travelTimeNT,
          t_travelTimeOT1: t_travelTimeOT1,
          t_travelTimeOT2: t_travelTimeOT2,
          t_budget_travelTimeNT: t_budget_travelTimeNT,
          t_budget_travelTimeOT1: t_budget_travelTimeOT1,
          t_budget_travelTimeOT2: t_budget_travelTimeOT2,
          t_travelKM: t_travelKM,
          t_budget_travelKM: t_budget_travelKM,
          t_accAndSnt: t_accAndSnt,
          t_budget_accAndSnt: t_budget_accAndSnt,
          t_forkliftCrane: t_forkliftCrane,
          t_budget_forkliftCrane: t_budget_forkliftCrane,
          t_toolHire: t_toolHire,
          t_budget_toolHire: t_budget_toolHire,
          t_casualHire: t_casualHire,
          t_trailerHire: t_trailerHire,
          t_budget_trailerHire: t_budget_trailerHire,
          t_budget_casualHire: t_budget_casualHire,
          t_other: t_other,
          t_budget_other: t_budget_other,
          t_transport: t_transport,
          t_budget_transport: t_budget_transport,
          t_workInstruction: t_workInstruction,
          t_invoiceNumber: t_invoiceNumber,
          t_quoteNumber: t_quoteNumber,
        },
      ],
    };

    return ticketBlob;
  };

  const ticketUpdate = (ticketId) => {
    // console.log(ticketId);
    const DataBlob = { ...combineData() };
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }

    let body = {};
    body = DataBlob;
    // console.log(body);
    const request = new Request(
      `${APIROOT}/api/r2_install_tickets/${ticketId}`,
      {
        method: 'post',
        headers,
        body: JSON.stringify(body),
      }
    );
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save ticket`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          setForceUpdate((val) => val + 1);
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }

          //CLOSE HERE
          closeModal();
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : `Connection Error !! ${error}`,
          'error'
        );
      });
  };

  const handle_t_Input = (event) => {
    switch (event.target.id) {
      case 'ir_stamped':
        set_ir_stamped(event.target.value);
        break;
      case 'dn_stamped':
        set_dn_stamped(event.target.value);
        break;
      case 'iw_stamped':
        set_iw_stamped(event.target.value);
        break;

      case 'labour_rate':
        set_labour_rate(event.target.value);
        break;
      case 'travel_rates':
        set_travel_rates(event.target.value);
        break;
      case 'travel_per_km':
        set_travel_per_km(event.target.value);
        break;

      case 't_labourTimeNT':
        set_t_labourTimeNT(event.target.value);
        break;
      case 't_labourTimeOT1':
        set_t_labourTimeOT1(event.target.value);
        break;
      case 't_labourTimeOT2':
        set_t_labourTimeOT2(event.target.value);
        break;

      case 't_budget_labourTimeNT':
        set_t_budget_labourTimeNT(event.target.value);
        break;
      case 't_budget_labourTimeOT1':
        set_t_budget_labourTimeOT1(event.target.value);
        break;
      case 't_budget_labourTimeOT2':
        set_t_budget_labourTimeOT2(event.target.value);
        break;

      case 't_travelTimeNT':
        set_t_travelTimeNT(event.target.value);
        break;
      case 't_travelTimeOT1':
        set_t_travelTimeOT1(event.target.value);
        break;
      case 't_travelTimeOT2':
        set_t_travelTimeOT2(event.target.value);
        break;

      case 't_budget_travelTimeNT':
        set_t_budget_travelTimeNT(event.target.value);
        break;
      case 't_budget_travelTimeOT1':
        set_t_budget_travelTimeOT1(event.target.value);
        break;
      case 't_budget_travelTimeOT2':
        set_t_budget_travelTimeOT2(event.target.value);
        break;

      case 't_travelKM':
        set_t_travelKM(event.target.value);
        break;
      case 't_budget_travelKM':
        set_t_budget_travelKM(event.target.value);
        break;

      case 't_accAndSnt':
        set_t_accAndSnt(event.target.value);
        break;
      case 't_budget_accAndSnt':
        set_t_budget_accAndSnt(event.target.value);
        break;
      case 't_forkliftCrane':
        set_t_forkliftCrane(event.target.value);
        break;
      case 't_budget_forkliftCrane':
        set_t_budget_forkliftCrane(event.target.value);
        break;
      case 't_toolHire':
        set_t_toolHire(event.target.value);
        break;
      case 't_budget_toolHire':
        set_t_budget_toolHire(event.target.value);
        break;
      case 't_casualHire':
        set_t_casualHire(event.target.value);
        break;
      case 't_budget_casualHire':
        set_t_budget_casualHire(event.target.value);
        break;
      case 't_trailerHire':
        set_t_trailerHire(event.target.value);
        break;
      case 't_budget_trailerHire':
        set_t_budget_trailerHire(event.target.value);
        break;
      case 't_other':
        set_t_other(event.target.value);
        break;
      case 't_budget_other':
        set_t_budget_other(event.target.value);
        break;
      case 't_transport':
        set_t_transport(event.target.value);
        break;
      case 't_budget_transport':
        set_t_budget_transport(event.target.value);
        break;

      case 't_workInstruction':
        set_t_workInstruction(event.target.value);
        break;
      case 't_invoiceNumber':
        set_t_invoiceNumber(event.target.value);
        break;
      case 't_quoteNumber':
        set_t_quoteNumber(event.target.value);
        break;

      default:
        break;
    }
  };

  const helpChecklist = [
    {
      id: 'ir_stamped',
      title: 'Installation Report Stamped & Signed:',
      value: ir_stamped,
    },
    {
      id: 'dn_stamped',
      title: 'Delivery Note Stamped & Signed:',
      value: dn_stamped,
    },
    {
      id: 'iw_stamped',
      title: 'Installation Warrantee Stamped & Signed:',
      value: iw_stamped,
    },
  ];

  const ratesList = [
    {
      id: 'labour_rate',
      title: 'LABOUR RATE:',
      value: labour_rate,
      itemType: 'number',
      minNum: 0,
    },
    {
      id: 'travel_rates',
      title: 'TRAVEL RATE:',
      value: travel_rates,
      itemType: 'number',
      maxNum: 1000,
    },
    {
      id: 'travel_per_km',
      title: 'TRAVEL PER KM:',
      value: travel_per_km,
      itemType: 'number',
      numStep: 0.25,
    },
  ];

  const labourList = [
    {
      id: 'LabHrsNT',
      title: 'LABOUR HRS NT:',
      value:
        timeData.nt_minutes.toFixed(2) === undefined || null
          ? 0
          : timeData.nt_minutes.toFixed(2),
      budget_id: 't_budget_labourTimeNT',
      budget: t_budget_labourTimeNT,
      itemType: 'number',
      minNum: 0,
      numStep: 0.25,
    },
    {
      id: 'LabHrsOT1',
      title: 'LABOUR HRS OT 1:',
      value:
        timeData.ot1_minutes.toFixed(2) === undefined || null
          ? 0
          : timeData.ot1_minutes.toFixed(2),
      budget_id: 't_budget_labourTimeOT1',
      budget: t_budget_labourTimeOT1,
      itemType: 'number',
      minNum: 0,
      numStep: 0.25,
    },
    {
      id: 'LabHrsOT2',
      title: 'LABOUR HRS OT 2:',
      value:
        timeData.ot2_minutes.toFixed(2) === undefined || null
          ? 0
          : timeData.ot2_minutes.toFixed(2),
      budget_id: 't_budget_labourTimeOT2',
      budget: t_budget_labourTimeOT2,
      itemType: 'number',
      minNum: 0,
      numStep: 0.25,
    },
  ];

  const labourCost = [
    {
      id: 'labourCost',
      title: 'LABOUR COST:',
      value:
        sumArrayObjects(labourList, 'value') === undefined || null
          ? 0
          : (
              sumArrayObjects(
                [
                  { value: timeData.nt_minutes.toFixed(2) },
                  { value: timeData.ot1_minutes.toFixed(2) * 1.5 },
                  { value: timeData.ot2_minutes.toFixed(2) * 2 },
                ],
                'value'
              ) * labour_rate
            ).toFixed(2),
      budget_id: 't_budget_labourTimeNT',
      budget:
        sumArrayObjects(labourList, 'budget') === undefined || null
          ? 0
          : (
              sumArrayObjects(
                [
                  { budget: t_budget_labourTimeNT },
                  { budget: t_budget_labourTimeOT1 * 1.5 },
                  { budget: t_budget_labourTimeOT2 * 2 },
                ],
                'budget'
              ) * labour_rate
            ).toFixed(2),
      itemType: 'info',
    },
  ];

  const travelList = [
    {
      id: 't_travelTimeNT',
      title: 'TRAVEL TIME NT:',
      value: t_travelTimeNT,
      budget_id: 't_budget_travelTimeNT',
      budget: t_budget_travelTimeNT,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_travelTimeOT1',
      title: 'TRAVEL TIME OT 1:',
      value: t_travelTimeOT1,
      budget_id: 't_budget_travelTimeOT1',
      budget: t_budget_travelTimeOT1,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_travelTimeOT2',
      title: 'TRAVEL TIME OT 2:',
      value: t_travelTimeOT2,
      budget_id: 't_budget_travelTimeOT2',
      budget: t_budget_travelTimeOT2,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
  ];

  const travelTimeCost = [
    {
      id: 't_travelKM',
      title: 'TRAVEL TIME COST:',
      value:
        sumArrayObjects(travelList, 'value') === undefined || null
          ? 0
          : (
              sumArrayObjects(
                [
                  { value: t_travelTimeNT },
                  { value: t_travelTimeOT1 * 1.5 },
                  { value: t_travelTimeOT2 * 2 },
                ],
                'value'
              ) * travel_rates
            ).toFixed(2),
      budget_id: 't_travelKM',
      budget:
        sumArrayObjects(travelList, 'budget') === undefined || null
          ? 0
          : (
              sumArrayObjects(
                [
                  { budget: t_budget_travelTimeNT },
                  { budget: t_budget_travelTimeOT1 * 1.5 },
                  { budget: t_budget_travelTimeOT2 * 2 },
                ],
                'budget'
              ) * travel_rates
            ).toFixed(2),
      itemType: 'info',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
  ];

  const travelListKM = [
    {
      id: 't_travelKM',
      title: 'TRAVEL KM:',
      value: t_travelKM,
      budget_id: 't_budget_travelKM',
      budget: t_budget_travelKM,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
  ];
  const travelListKMCost = [
    {
      id: 't_travelKMCost',
      title: 'TRAVEL KM COST:',
      value:
        multiplyArrayObjects(t_travelKM, travel_per_km) === undefined || null
          ? 0
          : multiplyArrayObjects(t_travelKM, travel_per_km),
      budget_id: 't_budget_travelKMCost',
      budget:
        multiplyArrayObjects(t_budget_travelKM, travel_per_km) === undefined ||
        null
          ? 0
          : multiplyArrayObjects(t_budget_travelKM, travel_per_km),
      itemType: 'info',
    },
  ];

  const costList = [
    {
      id: 't_accAndSnt',
      title: 'ACC & SNT:',
      value: t_accAndSnt,
      budget_id: 't_budget_accAndSnt',
      budget: t_budget_accAndSnt,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_forkliftCrane',
      title: 'FORKLIFT/CRANE HIRE:',
      value: t_forkliftCrane,
      budget_id: 't_budget_forkliftCrane',
      budget: t_budget_forkliftCrane,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_toolHire',
      title: 'TOOL HIRE:',
      value: t_toolHire,
      budget_id: 't_budget_toolHire',
      budget: t_budget_toolHire,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_casualHire',
      title: 'CASUALS WAGES:',
      value: t_casualHire,
      budget_id: 't_budget_casualHire',
      budget: t_budget_casualHire,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_trailerHire',
      title: 'TRAILER HIRE:',
      value: t_trailerHire,
      budget_id: 't_budget_trailerHire',
      budget: t_budget_trailerHire,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_other',
      title: 'OTHER:',
      value: t_other,
      budget_id: 't_budget_other',
      budget: t_budget_other,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
    {
      id: 't_transport',
      title: 'TRANSPORT:',
      value: t_transport,
      budget_id: 't_budget_transport',
      budget: t_budget_transport,
      itemType: 'number',
      minNum: 0,
      maxNum: 1000,
      numStep: 0.25,
    },
  ];

  const [totalArr, setTotalArr] = useState([]);

  const costTotals = [
    {
      id: 't_acc_snt',
      title: 'TOTAL COST:',
      value:
        sumArrayObjects(
          [...labourCost, ...travelTimeCost, ...travelListKMCost, ...costList],
          'value'
        ) === undefined || null
          ? 0
          : sumArrayObjects(
              [
                ...labourCost,
                ...travelTimeCost,
                ...travelListKMCost,
                ...costList,
              ],
              'value'
            ),
      budget_id: 't_budget_t_acc_snt',
      budget:
        sumArrayObjects(
          [...labourCost, ...travelTimeCost, ...travelListKMCost, ...costList],
          'budget'
        ) === undefined || null
          ? 0
          : sumArrayObjects(
              [
                ...labourCost,
                ...travelTimeCost,
                ...travelListKMCost,
                ...costList,
              ],
              'budget'
            ),
      itemType: 'number',
    },
  ];

  const TicketInfoList_1 = [
    {
      id: 'ticket_deliveryNoteNumber',
      title: 'DELIVERY NOTE NUMBER',
      value:
        newTicketData.dn_number === null || undefined
          ? ''
          : newTicketData.dn_number,
    },
  ];
  const TicketInfoList_2 = [
    {
      id: 't_quoteNumber',
      title: 'QUOTE NUMBER',
      value: t_quoteNumber,
    },
  ];
  const TicketInfoList_3 = [
    {
      id: 't_order_nr',
      title: 'CAPEX ORDER NUMBER',
      value:
        newTicketData.capex_number === null ||
        newTicketData.capex_number === undefined
          ? ''
          : newTicketData.capex_number,
    },
  ];
  const TicketInfoInputs = [
    {
      id: 't_workInstruction',
      title: 'WORK INSTRUCTION NUMBER',
      value: t_workInstruction,
    },
    { id: 't_invoiceNumber', title: 'INVOICE NUMBER', value: t_invoiceNumber },
  ];

  // console.log(newTicketData.capex_number);
  const blockIitem = (
    type,
    title,
    value,
    itemType,
    minNum,
    maxNum,
    numStep,
    budget
  ) => {
    switch (type) {
      case 'info':
        return (
          <Typography
            key={title}
            id={title}
            name={title}
          >{`${value}`}</Typography>
        );
      case 'input':
        return (
          <TextField
            key={title}
            id={title}
            size='small'
            name={title}
            onChange={handle_t_Input}
            type={itemType}
            inputProps={{
              step: numStep,
              min: minNum,
              max: maxNum,
            }}
            value={value}
            style={{
              background:
                value === undefined || value === '' || value === null
                  ? '#00334433'
                  : 'none',
              width: '100%',
            }}
          />
        );
      default:
        break;
    }
  };

  const createListItems = (arr, type) => {
    let style =
      type === 'info'
        ? {
            background: '#none',
            border: 'solid 2px #354775',
            paddingLeft: '5px',
            display: 'flex',
            alignItems: 'center',
            // justifyContent: 'center',
          }
        : { display: 'flex', alignItems: 'center' };
    return (
      <>
        {arr.map((list) => (
          <Grid container xs={12} md={12} key={list.id} height='40PX'>
            <Grid
              item
              xs={8}
              lg={8}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Typography align='left' style={ticketTypoTitle}>
                {list.title}
              </Typography>
            </Grid>
            <Grid item xs={4} lg={4} style={style}>
              {blockIitem(
                type,
                list.id,
                list.value,
                list.itemType,
                list.minNum,
                list.maxNum,
                list.numStep
              )}
            </Grid>
          </Grid>
        ))}
      </>
    );
  };
  const createDualListItems = (arr, type, subType) => {
    let style =
      type === 'info'
        ? {
            background: '#none',
            border: 'solid 2px #354775',
            paddingLeft: '5px',
            display: 'flex',
            alignItems: 'center',
          }
        : { display: 'flex', alignItems: 'center' };
    let sub_style =
      subType === 'info'
        ? {
            background: '#none',
            border: 'solid 2px #354775',
            paddingLeft: '5px',
            display: 'flex',
            alignItems: 'center',
          }
        : { display: 'flex', alignItems: 'center' };
    return (
      <>
        {arr.map((list) => (
          <Grid container xs={12} md={12} key={list.id} height='40PX'>
            <Grid
              item
              xs={6}
              lg={6}
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <Typography align='left' style={ticketTypoTitle}>
                {list.title}
              </Typography>
            </Grid>
            <Grid item xs={3} lg={3} style={style}>
              {blockIitem(
                type,
                list.id,
                list.value,
                list.itemType,
                list.minNum,
                list.maxNum,
                list.numStep
              )}
            </Grid>
            <Grid
              item
              xs={3}
              lg={3}
              // style={{ display: 'flex', alignItems: 'center' }}
              style={sub_style}
              className='noBorder'
            >
              {blockIitem(
                subType,
                list.budget_id,
                list.budget,
                list.itemType,
                list.minNum,
                list.maxNum,
                list.numStep
              )}
            </Grid>
          </Grid>
        ))}
      </>
    );
  };

  return (
    <Box
      // backgroundColor='#eeeeff'
      padding={1}
      style={{
        display: 'block',
        overflow: 'scroll',
        height: '80vh',
        width: '100%',
      }}
    >
      <Box align='right'>
        {' '}
        <Button onClick={props.closeModel}>X</Button>
      </Box>
      <Grid
        container
        xs={12}
        md={12}
        flexDirection='row'
        rowGap={1}
        columnGap={6}
        alignContent='flex-start'
      >
        <Grid
          container
          xs={12}
          md={4}
          flexDirection='row'
          rowGap={1}
          // columnGap={1}
          alignContent='flex-start'
        >
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              OPS Checklist
            </Typography>
            <Divider />
          </Grid>
          {createListItems(helpChecklist, 'input')}
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Applicable Rates
            </Typography>
            <Divider />
          </Grid>
          {createListItems(ratesList, 'input')}
          <Divider />
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Communication Notes
            </Typography>
            <Divider />
          </Grid>
          <Grid
            item
            xs={12}
            lg={12}
            style={{
              border: 'solid 2px #354775',
              background: '#none',
              // border: 'solid 2px #354775',
              // paddingLeft: '5px',
              padding: '1px',
              paddingTop: '-2px',
            }}
          >
            <GlobalNotes
              relationId={ticketID}
              relationType='ticketTableInstalls'
            />
          </Grid>
        </Grid>
        <Grid
          container
          xs={12}
          md={7}
          flexDirection='row'
          rowGap={1}
          // columnGap={1}
          alignContent='flex-start'
        >
          <Grid item xs={12} lg={12}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={6}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            {/* <Divider /> */}
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Actual Cost
            </Typography>
            {/* <Divider /> */}
          </Grid>
          <Grid item xs={12} lg={3}>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              Budget Amount
            </Typography>
            {/* <Divider /> */}
          </Grid>
          {createDualListItems(labourList, 'info', 'input')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          {createDualListItems(labourCost, 'info', 'info')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          {createDualListItems(travelList, 'input', 'input')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          {createDualListItems(travelTimeCost, 'info', 'info')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          {createDualListItems(travelListKM, 'input', 'input')}
          {createDualListItems(travelListKMCost, 'info', 'info')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>

          {createDualListItems(costList, 'input', 'input')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          {createDualListItems(costTotals, 'info', 'info')}
          <Grid item xs={12} lg={6} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            >
              {props.ticketData.ticket_num}
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>
          <Grid item xs={12} lg={3} minHeight='40px'>
            <Typography
              align='center'
              style={
                (ticketTypoTitle,
                { fontSize: '1.3em', textDecoration: 'underline' })
              }
            ></Typography>
            <Divider />
          </Grid>

          {createDualListItems(TicketInfoList_1, 'info')}
          {createDualListItems(TicketInfoList_2, 'input')}
          {createDualListItems(TicketInfoList_3, 'info')}
          {createDualListItems(TicketInfoInputs, 'input')}
        </Grid>
      </Grid>
      <Box align='right' style={{ padding: '15px' }}>
        <Button variant='contained' onClick={() => ticketUpdate(ticketID)}>
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default BillingNoteInstall;

async function checkClock(ticketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'ticket_hours_install',
    fetchid: ticketId,
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
